

/**
 * @name AddRelatedController
 * @description Controller to add related appointments
 * @param {type} $uibModalInstance Description
 * @param {type} Appointment Description
 * @param {type} AlertMessages Description
 * @param {type} appointment Description
 * @param {type} project Description
 */
function AddRelatedController(
  $uibModalInstance,
  Appointment,
  AlertMessages,
  appointment,
  project
) {
  let vm = this;

  // Defaults
  vm.newAppointment = {
    previously_paid: false,
    deposit_required: true,
    last_status: {},
    project: project.id
  };
  if (appointment.managed_by) {
    vm.newAppointment.managed_by = appointment.managed_by;
  }
  if (appointment.artist) {
    vm.newAppointment.artist = appointment.artist;
  }

  // Exposed Functions
  vm.submitDisabled = submitDisabled;
  vm.add = add;

  /**
  * @name submitDisabled
  * @description Disable the submit button
  * @return {Unknown} Unknown
  */
  function submitDisabled() {
    return ((vm.newAppointment.artist.id &&
    !vm.newAppointment.appointment_datetime) && (vm.newAppointment.artist.id &&
    !vm.newAppointment.appointment_date &&
    !vm.newAppointment.appointment_start_time));
  }

  /**
  * @name createAppointment
  * @description Function to create a new appointment.
  * @param {object} appointment The appointment to be created.
  */
  function add(appointment) {
    let status = 40;
    Appointment.create(appointment, status)
    .then(function(appointment) {
      $uibModalInstance.close(appointment);
    });
  }

  vm.cancel = function() {
    $uibModalInstance.dismiss();
  };
}

angular
  .module('inkfinder')
  .controller('AddRelatedController', AddRelatedController);



// WEBPACK FOOTER //
// ./components/appointments/appointment/add-related/add.related.controller.js